import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Output } from '@angular/core';
import { TechnicalEventsService } from '../technical-events/technical-events.service';

type TechnicalEventItem = {
  id: string;
  idTransaction: string;
  typeOperation: string;
  erroMensage?: string;
  dateExecution: string;
  idAccount: string;
  bankProvider?: string;
  shippingData?: string;
};

@Component({
  selector: 'app-table-technical-events',
  templateUrl: './table-technical-events.component.html',
  styleUrls: ['./table-technical-events.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('180ms ease-in-out')),
    ]),
  ],
})
export class TableTechnicalEventsComponent {
  public idTransaction = '';
  public type = '';
  public startDateIso?: string;
  public endDateIso?: string;

  public page = 1;
  public pageSize = 20;
  public total = 0;

  public logs: TechnicalEventItem[] = [];

  public displayedColumns: string[] = [
    'dateExecution',
    'idAccount',
    'typeOperation',
    'bankProvider',
    'idTransaction',
  ];

  public displayedColumnsWithExpand: string[] = ['expand', ...this.displayedColumns];

  public expandedRow: TechnicalEventItem | null = null;

  @Output() logsLoaded = new EventEmitter<TechnicalEventItem[]>();

  constructor(private technicalEventsService: TechnicalEventsService) {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');

    this.startDateIso = `${y}-${m}-${d}T00:00:00`;
    this.endDateIso = `${y}-${m}-${d}T23:59:59`;

    this.load();
  }

  trackById = (_: number, item: TechnicalEventItem) => item?.id ?? _;

  toggle(row: TechnicalEventItem): void {
    this.expandedRow = this.expandedRow === row ? null : row;
  }

  isExpanded(row: TechnicalEventItem): boolean {
    return this.expandedRow === row;
  }

  private prettyJsonFromString(raw: string): string {
    const t = (raw ?? '').toString().trim();
    if (!t) return '-';

    try {
      const obj = JSON.parse(t);
      return JSON.stringify(obj, null, 2);
    } catch {
      return t;
    }
  }


   
  errorPretty(row: TechnicalEventItem): string {
    const raw = (row?.erroMensage ?? '').toString().trim();
    if (!raw) return '-';


    try {
      const obj = JSON.parse(raw);
      return JSON.stringify(obj, null, 2);
    } catch {
      return JSON.stringify({ erroMensage: raw }, null, 2);
    }
  }

  shippingPretty(row: TechnicalEventItem): string {
    const raw = (row?.shippingData ?? '').toString().trim();
    if (!raw) return '-';

    return this.prettyJsonFromString(raw);
  }

  load(): void {
    const startDate = this.startDateIso ?? '';
    const endDate = this.endDateIso ?? '';

    if (!startDate || !endDate) {
      this.logs = [];
      this.total = 0;
      this.expandedRow = null;
      this.logsLoaded.emit(this.logs);
      return;
    }

    this.technicalEventsService
      .getLogIntegration({
        idTransaction: this.idTransaction || undefined,
        type: this.type || undefined,
        startDate,
        endDate,
        page: this.page,
        pageSize: this.pageSize,
      })
      .subscribe((value: any) => {
        this.logs = (value?.items ?? []) as TechnicalEventItem[];
        this.total = value?.total ?? this.logs.length;
        this.expandedRow = null;
        this.logsLoaded.emit(this.logs);
      });
  }

  pageChange(p: number): void {
    this.page = p;
    this.load();
  }
}